import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Rebate List")
], -1)
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table align-middle table-row-dashed fs-6 gy-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-muted fw-bold fs-7 text-uppercase gs-0" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Account"),
    /*#__PURE__*/_createElementVNode("th", null, "Role"),
    /*#__PURE__*/_createElementVNode("th", null, "Created On"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import { ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RebateList',
  setup(__props) {

const isLoading = ref(false);
const data = ref([]);

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
              _createVNode(_component_LoadingRing)
            ]))
          : (!isLoading.value && data.value.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_7, [
                _createVNode(_component_NoDataBox)
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, _toDisplayString(item.name), 1),
                    _createElementVNode("td", null, _toDisplayString(item.phone), 1),
                    _createElementVNode("td", null, _toDisplayString(item.email), 1),
                    _createElementVNode("td", null, _toDisplayString(item.address), 1)
                  ]))
                }), 128))
              ]))
      ])
    ])
  ]))
}
}

})